import { ReponseInfosClient } from '../../models/reponses/reponse-infos-client';
import { ReponseEnveloppe } from '../../models/reponses/reponse-enveloppe';

export const reponseInfosClient: ReponseEnveloppe<ReponseInfosClient> = {
    reponse:
        {
            "client":
                {
                    "nom" : "Robiaud",
                    "prenom" : "Aghate",
                    "libelleOffre" : "Fibre starter",
                    "emailDeContact" : "toto@titi.fr",
                    "dateFinEngagement" : "2024-06-01",
                    "ligne": "0612121212",
                    "lignes": ["0612121212", "0613131313"],
                    "statutResiliation": "AUTORISE",
                    "srr":false,
                    "cti":false,
                    "tiers":false,
                    "pro":false,
                    "redirect":"",
                    "cc": false,
                    "distrib": false,
                    "pdv": "00000"
                }
        }
}
